var _a;
import api from "../../utils/api/api.utils";
import { generateApi } from "../generators/generator.api";
import { GENERATOR_PARAMS } from "./invoice.constants";
export var getDetail = (_a = generateApi(GENERATOR_PARAMS), _a.getDetail), getPaged = _a.getPaged, getCount = _a.getCount;
export var markInvoicePaid = function (params) {
    var id = params.id;
    return api.post("/".concat(GENERATOR_PARAMS.basePathEntity, "/").concat(id, "/mark-paid"), {
        data: {},
        isV2: true,
    });
};
export var markInvoiceUnPaid = function (id) {
    return api.post("/".concat(GENERATOR_PARAMS.basePathEntity, "/").concat(id, "/mark-unpaid"), {
        data: {},
        isV2: true,
    });
};
